import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import ElectricalSidebar from './ElectricalSidebar';

function AutoChangeoverPanel() {
  useEffect(() => {
    AOS.init({ duration: 800 });
  }, []);

  return (
    <section className="py-5 bg-light mt-5" id="auto-changeover-panel">
      <div className="container">
        <div className="row">
          {/* Main Content */}
          <div className="col-lg-9 col-md-8 mb-4">
            {/* Title */}
            <div className="text-center mb-4" data-aos="fade-up">
              <h2 className="fw-bold">Auto Changeover Panel</h2>
              <p className="text-muted">
                Reliable switching solution for uninterrupted power supply in critical facilities.
              </p>
              <p className="text-muted fw-semibold">APFC PANEL &nbsp; | &nbsp; ELECTRIC LOW VOLTAGE PANEL</p>
            </div>

            {/* Description */}
            <div className="mb-4" data-aos="fade-up">
              <p className="text-muted lead">
                An Auto Changeover Panel is a vital electrical device that ensures automatic switching between the primary and backup power supplies when a power failure occurs. It is widely used in mission-critical environments like hospitals, data centers, and industrial units to maintain continuous power availability.
              </p>
            </div>

            <div className="row mb-4" data-aos="zoom-in">
              <div className="col-md-6 mb-3">
                <img
                  src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQMfkcCeTF3-E3UrJ7hx5SJ9T8V5peccZ3T2w&s"
                  alt="APFC Panel"
                  className="img-fluid rounded shadow"
                  style={{ maxHeight: '240px', objectFit: 'cover', width: '100%' }}
                />
              </div>
              <div className="col-md-6 mb-3">
                <img
                  src="https://www.accupanels.com/wp-content/uploads/2023/07/AUTO-CHANGE-OVER-PANEL-Use.jpg"
                  alt="Automatic Power Factor Correction Panel"
                  className="img-fluid rounded shadow"
                  style={{ maxHeight: '240px', objectFit: 'cover', width: '100%' }}
                />
              </div>
            </div>

            {/* Key Features */}
            <div className="mb-4" data-aos="fade-up">
              <h4 className="text-primary">Key Features</h4>
              <ul className="text-muted">
                <li><strong>Automatic Switching:</strong> Detects power loss and switches to backup supply (e.g., generator) instantly.</li>
                <li><strong>Seamless Transition:</strong> Ensures minimal disruption during source switching.</li>
                <li><strong>Control Unit:</strong> Continuously monitors input sources and initiates the changeover process.</li>
                <li><strong>Relays and Contactors:</strong> Execute the actual switching between sources.</li>
                <li><strong>Voltage & Current Monitoring:</strong> Keeps track of input parameters for safety and diagnostics.</li>
                <li><strong>Indicators & Alarms:</strong> Provide real-time visual/audible feedback on system status and faults.</li>
              </ul>
            </div>

            {/* Types */}
            <div className="mb-4 p-4 bg-white border-start border-4 border-success rounded" data-aos="fade-up">
              <h5 className="text-success fw-semibold">Types of Changeover Panels</h5>
              <ul className="text-muted mb-0">
                <li><strong>Manual Changeover Panels:</strong> Require human intervention; ideal for non-critical or low-cost setups.</li>
                <li><strong>Automatic Changeover Panels:</strong> Fully automated system ensuring real-time switching during outages.</li>
              </ul>
            </div>

            {/* Benefits */}
            <div className="mb-4" data-aos="fade-up">
              <h4 className="text-info">Benefits</h4>
              <ul className="text-muted">
                <li><strong>Minimized Downtime:</strong> Prevents operational halts during power failures.</li>
                <li><strong>Operational Continuity:</strong> Ensures uninterrupted operations in industries and medical facilities.</li>
                <li><strong>Data Protection:</strong> Avoids data loss in servers and network systems.</li>
                <li><strong>Real-Time Monitoring:</strong> Facilitates quick diagnostics and maintenance.</li>
              </ul>
            </div>

            {/* Applications */}
            <div className="mb-4" data-aos="fade-up">
              <h4 className="text-secondary">Applications</h4>
              <ul className="text-muted">
                <li><strong>Hospitals:</strong> Supports life-saving medical equipment without interruption.</li>
                <li><strong>Data Centers:</strong> Maintains uptime for servers and prevents data loss or outages.</li>
                <li><strong>Industrial Facilities:</strong> Keeps machinery running and prevents production loss.</li>
              </ul>
            </div>

            {/* CTA */}
            <div className="p-4 bg-white border-start border-4 border-primary rounded shadow-sm" data-aos="fade-up">
              <h5 className="text-dark fw-semibold">Need Reliable Changeover Panels?</h5>
              <p className="mb-2 text-muted">
                We offer fully customizable auto changeover panel solutions for mission-critical needs.
              </p>
              <a
                href="/contact"
                className="btn"
                style={{
                  backgroundColor: '#08717A',
                  color: '#fff',
                  border: 'none',
                }}
              >
                Get In Touch
              </a>
            </div>
          </div>

          {/* Sidebar */}
          <ElectricalSidebar />
        </div>
      </div>
    </section>
  );
}

export default AutoChangeoverPanel;
